import { OfferValue } from './OfferValue'

export enum PaymentTypes {
  CARD = 'card',
  GOOGLE = 'google',
  APPLE = 'apple'
}

export interface PaymentInfoData {
  creditcard?: string
  creditcardValid?: boolean
  expiry?: string
  offer?: OfferValue
  termsAccepted?: boolean
  cvc?: string
  payFrameData?: RebillyTokenData
  token?: string
  paymentInstrument?: {
    paymentCardId?: string | null
    method?: string | null
  }
}

export interface RebillyTokenData {
  id: string
  method: string
  paymentInstrument: RebillyPaymentInstrument
}
interface RebillyPaymentInstrument {
  type: string
  amount: number
  currency: string
  descriptor: string
  bin: string
  last4: string
  brand: string
  expMonth: number
  expYear: number
}
